import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { MASCOTE_SPACE_TCHAU } from "../appAssistenteIA.constants";

type AppAssistenteIAHeaderProps = {
	readonly pendente: boolean;
	readonly expandido: boolean;
	readonly onToggleExpandido: () => void;
	readonly onClose: () => void;
	readonly onLimparConversa: () => void;
};

export default function AppAssistenteIAHeader({
	expandido,
	pendente,
	onToggleExpandido,
	onClose,
	onLimparConversa,
}: AppAssistenteIAHeaderProps) {
	return (
		<header className="flex shrink-0 items-center gap-3 border-b bg-favorite px-4 py-1.5 text-primary-foreground">
			<span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white shadow-md">
				<img src={MASCOTE_SPACE_TCHAU} alt="Mascote SPACE" className="h-18 w-18 object-cover object-top" />
			</span>

			<div className="min-w-0 flex-1">
				<div className="flex items-center gap-2">
					<h2 className="truncate text-lg font-semibold leading-5">ASTRO</h2>
					<h3 className="text-md text-secondary-foreground border border-muted-foreground rounded px-1 bg-primary">
						IA
					</h3>
				</div>
			</div>

			<div className="flex shrink-0 items-center gap-1">
				<Tooltip title="Limpar conversa" placement="bottom">
					<span className="inline-flex">
						<IconButton
							size="small"
							className="text-primary-foreground"
							aria-label="Limpar conversa"
							onClick={onLimparConversa}
							disabled={pendente}
						>
							<FuseSvgIcon size={18}>lucide:rotate-ccw</FuseSvgIcon>
						</IconButton>
					</span>
				</Tooltip>
				<Tooltip title={expandido ? "Reduzir" : "Expandir"} placement="bottom">
					<IconButton
						size="small"
						className="text-primary-foreground"
						aria-label={expandido ? "Reduzir chat" : "Expandir chat"}
						onClick={onToggleExpandido}
					>
						<FuseSvgIcon size={18}>{expandido ? "lucide:minimize-2" : "lucide:maximize-2"}</FuseSvgIcon>
					</IconButton>
				</Tooltip>
				<Tooltip title="Fechar" placement="bottom">
					<IconButton
						size="small"
						className="text-primary-foreground"
						aria-label="Fechar chat"
						onClick={onClose}
					>
						<FuseSvgIcon size={18}>lucide:x</FuseSvgIcon>
					</IconButton>
				</Tooltip>
			</div>
		</header>
	);
}
